import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="checklists" />;

export const Route = createFileRoute("/es/downloads/checklists/$slug")({
  loader: ({ params }) => loadContentMeta("checklists", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/downloads/checklists/${params.slug}`, loaderData),
  component: ContentPostRoute,
});
